function checkVal(val) {
    const check=(isNull)=>{
        return isNull === '' || isNull === undefined || isNull === null || isNull === 'undefined'
    }
    const checkLength=(length)=>{
        return length < 1 || length === '' || length === undefined || length === null
    }
    const checkSum=(arr)=>{
        if(arr.length>0){
            return arr.reduce((prev,curr)=>prev+curr)
        }else{
            return ""
        }
        
       
    }
    

   const statusFormat=(obj)=>{
        var statusDesc="";
        if(obj.homeworkCheck==1){
          statusDesc="完成"
        }else if(
          obj.homeworkCheck==0
        ){
          statusDesc="未完成"
        }else{
        statusDesc="未批改"
        }
        return statusDesc;
        }



    return {
        check,
        checkLength,
        checkSum,
        statusFormat
       
    }
}

export  default checkVal;